import {
  FETCH_PURCHASE_ORDERS,
  FETCH_PURCHASE_ORDER_DETAIL,
  CREATE_MULTIPLE_PURCHASE_ORDER,
  FETCH_MULTIPLE_PURCHASE_ORDER,
  CREATE_PURCHASE_ORDER,
  DELETE_PURCHASE_ORDER,
  CREATE_PURCHASE_ORDER_ITEM_LABEL,
  DELETE_PURCHASE_ORDER_ITEM_LABEL,
  CLEAR_PURCHASE_ORDER_DETAIL,
} from "./types";

import { ITEMS_PER_PAGE } from "../../constants/constants";

const INITIAL_STATE = {
  purchaseOrdersList: {
    purchaseOrders: [],
    hasMore: false,
    error: null,
    loading: false,
  },
  purchaseOrderDetail: {
    purchaseOrder: undefined,
    purchaseOrders: {},
    error: null,
    loading: false,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // --------------------------------------------------------------------------
    // FETCH_PURCHASE_ORDERS
    // --------------------------------------------------------------------------
    case FETCH_PURCHASE_ORDERS.init:
      return {
        ...state,
        purchaseOrdersList: { ...state.purchaseOrdersList, hasMore: false, error: null, loading: true },
      };
    case FETCH_PURCHASE_ORDERS.success:
      return {
        ...state,
        purchaseOrdersList: {
          ...state.purchaseOrdersList,
          purchaseOrders: action.payload.results,
          hasMore: action.payload.next !== null,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_PURCHASE_ORDERS.failure:
      return {
        ...state,
        purchaseOrdersList: {
          ...state.purchaseOrdersList,
          purchaseOrders: [],
          pages: 1,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_PURCHASE_ORDERS
    // --------------------------------------------------------------------------
    case FETCH_PURCHASE_ORDER_DETAIL.init:
      return {
        ...state,
        purchaseOrderDetail: { ...state.purchaseOrderDetail, error: null, loading: true },
      };
    case FETCH_PURCHASE_ORDER_DETAIL.success:
      return {
        ...state,
        purchaseOrderDetail: {
          ...state.purchaseOrderDetail,
          purchaseOrders: { [action.payload.id]: action.payload },
          purchaseOrder: action.payload,
          error: null,
          loading: false,
        },
      };
    case FETCH_MULTIPLE_PURCHASE_ORDER.success:
      return {
        ...state,
        purchaseOrderDetail: {
          ...state.purchaseOrderDetail,
          purchaseOrders: { ...state.purchaseOrderDetail.purchaseOrders, [action.payload.id]: action.payload },
          error: null,
          loading: false,
        },
      };
    case FETCH_PURCHASE_ORDER_DETAIL.failure:
      return {
        ...state,
        purchaseOrderDetail: {
          ...state.purchaseOrderDetail,
          purchaseOrder: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // CREATE_PURCHASE_ORDER
    // --------------------------------------------------------------------------
    case CREATE_PURCHASE_ORDER.init:
      return {
        ...state,
        purchaseOrderDetail: { ...state.purchaseOrderDetail, error: null, loading: true },
      };
    case CREATE_PURCHASE_ORDER.success:
      return {
        ...state,
        purchaseOrderDetail: { ...state.purchaseOrderDetail, purchaseOrder: action.payload, error: null, loading: false },
      };
    case CREATE_MULTIPLE_PURCHASE_ORDER.success:
      return {
        ...state,
        purchaseOrderDetail: {
          ...state.purchaseOrderDetail,
          purchaseOrders: { ...state.purchaseOrderDetail.purchaseOrders, [action.payload.id]: action.payload },
          error: null,
          loading: false,
        },
      };
    case CREATE_PURCHASE_ORDER.failure:
      return {
        ...state,
        purchaseOrderDetail: {
          ...state.purchaseOrderDetail,
          purchaseOrder: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // DELETE_PURCHASE_ORDER
    // --------------------------------------------------------------------------
    case DELETE_PURCHASE_ORDER.init:
      return {
        ...state,
        purchaseOrderDetail: { ...state.purchaseOrderDetail, error: null, loading: true },
      };
    case DELETE_PURCHASE_ORDER.success:
      const poCopy = state.purchaseOrderDetail.purchaseOrders;
      delete poCopy[action.payload];
      return {
        ...state,
        purchaseOrderDetail: {
          ...state.purchaseOrderDetail,
          purchaseOrders: poCopy,
          error: null,
          loading: false,
        },
      };
    case DELETE_PURCHASE_ORDER.failure:
      return {
        ...state,
        purchaseOrderDetail: {
          ...state.purchaseOrderDetail,
          purchaseOrder: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // CLEAR_PURCHASE_ORDER
    // --------------------------------------------------------------------------
    case CLEAR_PURCHASE_ORDER_DETAIL:
      return {
        ...state,
        purchaseOrderDetail: {
          purchaseOrder: undefined,
          purchaseOrders: {},
          error: null,
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // CREATE_PURCHASE_ORDER_ITEM_DETAIL
    // --------------------------------------------------------------------------

    case CREATE_PURCHASE_ORDER_ITEM_LABEL.success: {
      let new_items = state.purchaseOrderDetail.purchaseOrder.items;
      const label = action.payload;
      const item_index = state.purchaseOrderDetail.purchaseOrder.items.findIndex((item) => item.id === label.po_item);
      if (item_index > -1) new_items[item_index].labels = [...new_items[item_index].labels, label];

      return {
        ...state,
        purchaseOrderDetail: {
          ...state.purchaseOrderDetail,
          purchaseOrder: {
            ...state.purchaseOrderDetail.purchaseOrder,
            items: new_items,
          },
        },
      };
    }
    // --------------------------------------------------------------------------
    // DELETE_PURCHASE_ORDER_ITEM_DETAIL
    // --------------------------------------------------------------------------

    case DELETE_PURCHASE_ORDER_ITEM_LABEL.success: {
      let new_items = state.purchaseOrderDetail.purchaseOrder.items;
      const item_id = action.payload.po_item;
      const label_id = action.payload.label_id;
      const item_index = state.purchaseOrderDetail.purchaseOrder.items.findIndex((item) => item.id === item_id);
      if (item_index > -1 && "labels" in state.purchaseOrderDetail.purchaseOrder.items[item_index]) {
        const label_index = state.purchaseOrderDetail.purchaseOrder.items[item_index].labels.findIndex((label) => label.id === label_id);
        if (label_index > -1) new_items[item_index].labels.splice(label_index, 1);
      }

      return {
        ...state,
        purchaseOrderDetail: {
          ...state.purchaseOrderDetail,
          purchaseOrder: {
            ...state.purchaseOrderDetail.purchaseOrder,
            items: new_items,
          },
        },
      };
    }
    default:
      return state;
  }
};
